import FooterColumnsLayout from './FooterColumnsLayout'

function FooterColumnsDark({ config }) {
  return <FooterColumnsLayout config={config} variant="dark" />
}

export default FooterColumnsDark
